

















































































































































import { Vue, Prop, Component } from 'vue-property-decorator'
import commonHeader from './common/commonHeader.vue'
import downloadApp from "./common/downloadApp.vue"
import channelItem from './channel/channelItem2.vue'
import lessonDesc from './channel/lessonDesc.vue'
import videoModal from './media/videoModal.vue'
import audioModal from './media/audioModal.vue'
import audioM3u8Modal from './media/audioM3u8Modal.vue'
import commentModal from './comment/commentModal.vue'
import addComment from './comment/addComment.vue'
import intro from './comment/intro.vue'
import * as util from '../util'
import * as _ from 'underscore'
import * as utils from '@ivy/fts/utils'
import * as weixin from '@ivy/fts/weixin'
import noData from './comps/noData.vue'
import openApp from '@ivy/fts/openApp'
import channelClassItem from './channel/channelClassItem.vue'
@Component({
  components: {
    videoModal,
    audioModal,
    commonHeader,
    channelItem,
    lessonDesc,
    commentModal,
    addComment,
    intro,
    downloadApp,
    audioM3u8Modal,
    channelClassItem
  }
})
export default class LessonPlayPage extends Vue {
  isXcxWeb
  durationStartTime: number = 0 // 区间开始时间
  lessonId: any = ''
  hasBought: any = false
  lessonDetail: any = {}
  courseDetail: any = {}
  item: any = {}
  commentObj: any = {}
  hasDown: boolean = false
  isAdminCheck: any = ''
  playList: any[] = []
  showPlayList: any = false
  playType: string = 'loop'
  finishRate: any = 0.85
  recommends: any[] = []
  userInfo: any = {}
  pointMap: object = {
    audio: '专栏_音频',
    video: '专栏_视频'
  }
  get hasAccess() {
    let isLimitBuy = this.courseDetail && this.courseDetail.activity && this.courseDetail.activity.activity_type === 'limit_free'
    if (this.hasBought || this.courseDetail.type === 'free' || this.lessonDetail.is_try || isLimitBuy) return true
    return false
  }
  get isMp3() {
    return /.mp3/.test(this.lessonDetail.lesson_url)
  }
  async created() {
    this.isXcxWeb = utils.isXcxWeb()
  }
  async mounted() {
    // 这个地方是为了后台管理员上新查看未发布课程时，可以预览效果
    let isAdminCheck = await this.$store.login()
    this.userInfo = isAdminCheck
    let { from } = this.$route.query
    this.isAdminCheck = isAdminCheck === 'adminCheck' ? 'adminCheck' : ''
    this.playType = utils.storeGet('playType') || 'loop'
    let { lessonId } = this.$route.query
    let idResult = /^(\d+)/.exec(`${lessonId}`)
    if (!idResult) return this.$MessageBox('地址有误，请退出重试~')
    this.hasDown = true
    lessonId = idResult[0]
    this.lessonId = lessonId
    let { data } = await this.$axios.get(`/api/mobile/knowlege/course/getLessonDetailById2`, {
      params: { lessonId, isAdminCheck: this.isAdminCheck, includes: "hasBought,playList,courseDetail", isNew: 1 }
    })
    let { lessonDetail, courseDetail, playList, recommends } = data
    this.$title(lessonDetail.title)
    this.hasBought = isAdminCheck === 'adminCheck' ? true : courseDetail.has_bought
    courseDetail.pic_url = util.transAliImgResize(courseDetail.pic_url, 122, 122)
    this.courseDetail = courseDetail
    this.lessonDetail = lessonDetail
    this.recommends = recommends
    this.playList = playList
    if (lessonDetail.type === 'text' || from === 'game') this.addPlayCount()
    this.setShare(this.lessonDetail.shareData)
  }
  goApp() {
    openApp()
  }
  toCourseDetail(item: any = {}) {
    this.$router.push({
      path: 'channelDetail',
      query: {
        id: item.id || this.courseDetail.id
      }
    })
  }
  async showBuyPrompt(type) {
    if (this.hasBought) return
    let opt: any = {
      title: '提示',
      message: type === 'end' ? '试看已结束，如需收看该专栏完整内容，请购买' : '付费视频，购买后可观看',
      showCancelButton: true,
      confirmButtonText: '购买',
      confirmButtonHighlight: true,
      confirmButtonClass: 'prompt-text',
      cancelButtonClass: 'prompt-text'
    }
    let r = await this.$MessageBox(opt)
    if (r === 'confirm') this.toCourseDetail()
  }
  addPlayCount() {
    let lessonId = this.lessonDetail.id
    let conf = { disableLoading: true }
    this.$axios.post('/api/mobile/knowlege/uti/updateLessonPlayCount', { lessonId })
    this.$store.uploadPoint({
        module: 'play_times',
        p1: [ 'audio', 'video' ].includes(this.lessonDetail.type) ? this.lessonDetail.type : '非视频和音频',
        p2: [ 'audio', 'video' ].includes(this.lessonDetail.type) ? this.pointMap[this.lessonDetail.type] : '非视频和音频',
        p4: lessonId,
        openid: this.userInfo && this.userInfo.openid || '',
        union_id: this.userInfo && this.userInfo.unionid || '',
        sys_type: 'h5',
    })
    // { disableLoading: true }
  }
  accountPlayFinish() {
    let lessonId = this.lessonDetail.id
    let courseId = this.courseDetail.id
    this.$axios.post('/api/mobile/knowlege/uti/accountLessonStatistics', { lessonId, courseId, type: 'play_finish' })
    this.$store.uploadPoint({
        module: 'play_over',
        p1: [ 'audio', 'video' ].includes(this.lessonDetail.type) ? this.lessonDetail.type : '非视频和音频',
        p2: [ 'audio', 'video' ].includes(this.lessonDetail.type) ? this.pointMap[this.lessonDetail.type] : '非视频和音频',
        p4: lessonId,
        openid: this.userInfo && this.userInfo.openid || '',
        union_id: this.userInfo && this.userInfo.unionid || '',
        sys_type: 'h5',
    })
    // {disableLoading: true}
  }
  playDurationPoint(type) {
    if (type === 'play') {
      this.durationStartTime = new Date().getTime()
    } else if (type === 'pause') {
      const duration = new Date().getTime() - this.durationStartTime
      this.$store.uploadPoint({
        module: 'play_duration',
        p1: [ 'audio', 'video' ].includes(this.lessonDetail.type) ? this.lessonDetail.type : '非视频和音频',
        p2: [ 'audio', 'video' ].includes(this.lessonDetail.type) ? this.pointMap[this.lessonDetail.type] : '非视频和音频',
        p3: Math.floor( duration / 1000),
        p4: this.lessonDetail.id,
        openid: this.userInfo && this.userInfo.openid || '',
        union_id: this.userInfo && this.userInfo.unionid || '',
        sys_type: 'h5',
      })
    }
  }
  refresh(commentObj) {
    this.commentObj = commentObj
    let sendObjRef: any = this.$refs.commentModal
    sendObjRef.sendObj(commentObj)
  }
  async togglePlay(item, isEnd = false) {
    if (!this.hasBought) return this.showBuyPrompt('end')
    item = !isNaN(item) ? this.getItem(item) : item
    if (item && +item.is_lock) return this.$Toast('课程未解锁，解锁后才能学习哦！')
    let playType = this.playType
    if (isEnd && playType === 'single' && this.lessonDetail.type === 'audio') {
      let audioRef: any = this.$refs.audioModal
      return await audioRef.playAudio()
    }
    if (isEnd && playType === 'single' && this.lessonDetail.type === 'video') {
      let audioRef: any = this.$refs.videoModal
      return await audioRef.playVideo()
    }
    if (item) {
      window.location.replace(`//${window.location.host}/knowlege/lessonPlayPage?lessonId=${item.id}`)
    }
  }
  getItem(flag) {
    let curIndex = _.findIndex(this.playList, { id: this.lessonDetail.id })
    let index = curIndex + +flag
    index = index === this.playList.length ? 0 : index === -1 ? this.playList.length - 1 : index
    return this.playList[index]
  }
  toggleAudioPlayType() {
    this.playType = this.playType === 'loop' ? 'single' : 'loop'
    try {
      utils.storeSet('playType', this.playType)
    } catch (e) {
      console.log('e => ', e)
    }
  }
  async setShare(opt) {
    await weixin.wxConfigReady()
    let options = {
      title: opt.title,
      desc: opt.content,
      imgUrl: opt.pic_url,
      link: opt.url,
    }
    await weixin.weixinShare(options)
  }
  toCenterCourseList() {
    util.toCenterKnowledgeList()
  }
  toGame() {
    window.location.href = this.lessonDetail.gameUrl
  }
}
